export default __webpack_public_path__ + "static/media/loader-homeicon.ed305799.svg";